export class DateFormats {
	// we need to update a bunch of stuff to svelte 5 runes
	// private static Locale = $derived(Language === 'da' ? 'da-DK' : 'en-GB');
	public static Locale = 'da-DK';
	public static LocaleTimeZone = 'Europe/Copenhagen';

	private static getMonthNum(zonedDatetime: Date): number {
		// let zonedDatetime = utcToZonedTime(date, 'Europe/Copenhagen');
		return zonedDatetime.getFullYear() * 12 + zonedDatetime.getMonth();
	}

	public static toString(datetime: string | number | Date, options: Intl.DateTimeFormatOptions) {
		// let zonedDatetime = utcToZonedTime(datetime, 'Europe/Copenhagen');
		return new Date(datetime).toLocaleString(this.Locale, {
			timeZone: this.LocaleTimeZone,
			...options
		});
	}

	// 11/06
	// 11/06 2021
	public static dayOfMonth(datetime: string | number | Date, canHaveYear = false) {
		const zonedDatetime = new Date(datetime);

		let options: Intl.DateTimeFormatOptions = {
			month: '2-digit',
			day: '2-digit'
		};

		if (canHaveYear) {
			const now = new Date();

			if (
				zonedDatetime.getFullYear() < now.getFullYear() ||
				(zonedDatetime.getFullYear() !== now.getFullYear() &&
					this.getMonthNum(zonedDatetime) - this.getMonthNum(now) > 6)
			) {
				options = {
					...options,
					year: 'numeric'
				};
			}
		}
		const string = zonedDatetime.toLocaleString(this.Locale, {
			...options,
			timeZone: this.LocaleTimeZone
		});
		return string.replace(/\.(?=\d{1,2})/, '/').replace(/\.(?=\d{4})/, ' ');
	}

	// 19.30
	public static timeOfDay(datetime: string | number | Date) {
		return new Date(datetime).toLocaleString(this.Locale, {
			hour: '2-digit',
			minute: '2-digit',
			timeZone: this.LocaleTimeZone
		});
	}

	// November
	// Nov 2021
	public static monthName(datetime: string | number | Date) {
		// let zonedDatetime = utcToZonedTime(datetime, 'Europe/Copenhagen');
		const zonedDatetime = new Date(datetime);
		const now = new Date();
		let options: Intl.DateTimeFormatOptions = {
			month: 'long',
			timeZone: this.LocaleTimeZone
		};
		if (
			zonedDatetime.getFullYear() < now.getFullYear() ||
			(zonedDatetime.getFullYear() !== now.getFullYear() &&
				this.getMonthNum(zonedDatetime) - this.getMonthNum(now) > 6)
		) {
			options = {
				month: 'short',
				year: 'numeric'
			};
		}
		const string = zonedDatetime.toLocaleString(this.Locale, options);

		return string;
	}

	// November 2020
	public static monthTitle(datetime: string | number | Date) {
		// let zonedDatetime = utcToZonedTime(datetime, 'Europe/Copenhagen');
		const zonedDatetime = new Date(datetime);
		const options: Intl.DateTimeFormatOptions = {
			month: 'long',
			year: 'numeric',
			timeZone: this.LocaleTimeZone
		};
		const string = zonedDatetime.toLocaleString(this.Locale, options);

		// return string.toUpperCase();
		return string;
	}

	// 1. september
	// 1. sep 2021
	public static basicDate(datetime: string | number | Date) {
		// let zonedDatetime = utcToZonedTime(datetime, 'Europe/Copenhagen');
		const zonedDatetime = new Date(datetime);
		const now = new Date();
		let options: Intl.DateTimeFormatOptions = {
			day: 'numeric',
			timeZone: this.LocaleTimeZone
		};

		if (
			zonedDatetime.getFullYear() < now.getFullYear() ||
			(zonedDatetime.getFullYear() !== now.getFullYear() &&
				this.getMonthNum(zonedDatetime) - this.getMonthNum(now) > 6)
		) {
			options = {
				...options,
				year: 'numeric',
				month: 'short'
			};
		} else {
			options = {
				...options,
				month: 'long'
			};
		}

		return zonedDatetime.toLocaleString(this.Locale, options);
	}

	// Søn. 04/01
	// 04/01 2021
	public static dateWithWeekday(datetime: string | number | Date) {
		// let zonedDatetime = utcToZonedTime(datetime, 'Europe/Copenhagen');
		const zonedDatetime = new Date(datetime);
		const now = new Date();
		let options: Intl.DateTimeFormatOptions = {
			month: '2-digit',
			day: '2-digit',
			timeZone: this.LocaleTimeZone
		};
		if (
			zonedDatetime.getFullYear() < now.getFullYear() ||
			(zonedDatetime.getFullYear() !== now.getFullYear() &&
				this.getMonthNum(zonedDatetime) - this.getMonthNum(now) > 6)
		) {
			options = {
				...options,
				year: 'numeric'
			};
		} else {
			options = {
				...options,
				weekday: 'short'
			};
		}
		const string = zonedDatetime.toLocaleString(this.Locale, options);

		return string.replace(/\.(?=\d{1,2})/, '/').replace(/\.(?=\d{4})/, ' ');
	}

	// Søndag 1. sep
	// Søn. 1. sep 2021
	public static dateWithWeekdayAlways(datetime: string | number | Date) {
		// let zonedDatetime = utcToZonedTime(datetime, 'Europe/Copenhagen');
		const zonedDatetime = new Date(datetime);
		const now = new Date();
		let options: Intl.DateTimeFormatOptions = {
			day: 'numeric'
		};

		if (
			zonedDatetime.getFullYear() < now.getFullYear() ||
			(zonedDatetime.getFullYear() !== now.getFullYear() &&
				this.getMonthNum(zonedDatetime) - this.getMonthNum(now) > 6)
		) {
			options = {
				...options,
				year: 'numeric',
				month: 'short',
				weekday: 'short'
			};
		} else {
			options = {
				...options,
				month: 'long',
				weekday: 'long'
			};
		}
		const string = zonedDatetime.toLocaleString(this.Locale, options);

		return string.replace(/\.(?=\d{1,2})/, '/').replace(/\.(?=\d{4})/, ' ');
	}

	// Tirsdag
	public static weekday(datetime: string | number | Date) {
		// let zonedDatetime = utcToZonedTime(datetime, 'Europe/Copenhagen');
		const zonedDatetime = new Date(datetime);
		return zonedDatetime.toLocaleString(this.Locale, {
			weekday: 'long',
			timeZone: this.LocaleTimeZone
		});
	}

	// 2025-12-31
	public static dateSlug(date: string | number | Date) {
		// let zonedDatetime = utcToZonedTime(date, 'Europe/Copenhagen');
		const zonedDatetime = new Date(date);
		const year = zonedDatetime.getFullYear();
		const month = zonedDatetime.getMonth() + 1;
		const day = zonedDatetime.getDate();
		return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
	}

	// Tirsdag 16. Juli, kl. 11.30
	// Tirsdag 16. Jul. 2024, kl. 11.30
	public static long(date: string | number | Date) {
		// let zonedDatetime = utcToZonedTime(date, 'Europe/Copenhagen');
		const zonedDatetime = new Date(date);
		const now = new Date();
		let options: Intl.DateTimeFormatOptions = {
			weekday: 'long',
			month: '2-digit',
			day: '2-digit',
			hour: '2-digit',
			minute: '2-digit'
		};

		if (
			zonedDatetime.getFullYear() < now.getFullYear() ||
			(zonedDatetime.getFullYear() !== now.getFullYear() &&
				this.getMonthNum(zonedDatetime) - this.getMonthNum(now) > 6)
		) {
			options = {
				...options,
				month: 'short',
				year: 'numeric'
			};
		} else {
			options = {
				...options,
				month: 'long'
			};
		}

		const string = zonedDatetime.toLocaleString(this.Locale, options);

		return string.replace(/ (?=kl\.)/, ', ');
	}
}
